exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parent-project-on-hold .deliverable-projects .department-title {\n  font-weight: 600 !important;\n}", ""]);

// exports
